import { authApi } from "shared/api/authApi";

export const loginRequest = (credentials) => {
  return authApi.login(credentials);
};
